(function () {
  function enhanceSlideshow(slideshow) {
    if (!slideshow || slideshow.dataset.kmSwipeEnhanced === '1') return;
    slideshow.dataset.kmSwipeEnhanced = '1';

    // Ensure Horizon marks gallery in-viewport so overflow-x:scroll applies
    slideshow.setAttribute('in-viewport', '');

    var scroller = slideshow.querySelector('slideshow-slides');
    if (!scroller) return;

    // Force scrollable snap (belt + suspenders over theme CSS)
    scroller.style.overflowX = 'scroll';
    scroller.style.scrollSnapType = 'x mandatory';
    scroller.style.webkitOverflowScrolling = 'touch';
    scroller.style.touchAction = 'pan-x';

    // Prevent zoom dialog from stealing a swipe gesture
    var moved = false;
    var startX = 0;
    scroller.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      moved = false;
      startX = e.touches[0].clientX;
    }, { passive: true });
    scroller.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;
      if (Math.abs(e.touches[0].clientX - startX) > 12) moved = true;
    }, { passive: true });
    scroller.addEventListener('click', function (e) {
      if (moved) {
        e.preventDefault();
        e.stopPropagation();
        moved = false;
      }
    }, true);

    // Touch/pointer drag polyfill: Horizon only binds mousedown for drag
    scroller.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse') return; // mouse already handled
      if (e.button != null && e.button !== 0) return;
      // Synthesize mousedown so Slideshow.#handleMouseDown runs
      try {
        var ev = new MouseEvent('mousedown', {
          bubbles: true,
          cancelable: true,
          clientX: e.clientX,
          clientY: e.clientY,
          screenX: e.screenX,
          screenY: e.screenY,
          buttons: 1,
          view: window
        });
        scroller.dispatchEvent(ev);
      } catch (err) {}
    }, { passive: true });
  }

  function enhanceAll() {
    document.querySelectorAll('media-gallery slideshow-component, .product-information__media slideshow-component, slideshow-component').forEach(enhanceSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }
  // Theme sections can hydrate late
  document.addEventListener('shopify:section:load', enhanceAll);
  setTimeout(enhanceAll, 800);
})();
